import { render } from "./HistoryForm.vue?vue&type=template&id=67722280&scoped=true"
import script from "./HistoryForm.vue?vue&type=script&lang=js"
export * from "./HistoryForm.vue?vue&type=script&lang=js"

import "./HistoryForm.vue?vue&type=style&index=0&id=67722280&scoped=true&lang=scss"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67722280"]])

export default __exports__